import { render, staticRenderFns } from "./PersistCargaMedlogView.vue?vue&type=template&id=6abf00bb&"
import script from "./PersistCargaMedlogView.vue?vue&type=script&lang=ts&"
export * from "./PersistCargaMedlogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports